import { useState } from 'react'

import { useFetch } from 'hooks'

import {
  Container,
  ContentHeader,
  Page,
  LoadingFeedback,
  MenuButton,
  ButtonLogs,
} from 'components'
import { TabsForm } from './components'

import * as service from 'service'

const ContractEdit = ({ match }) => {
  const {
    params: { contractId },
  } = match

  const [tab, setTab] = useState('contract')

  const { response, isLoading, refresh } = useFetch(
    service.dponet.paymentContract.show,
    { paymentContractId: contractId },
    [tab],
  )

  return (
    <Page title="Editar contrato">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          menu="Contrato"
          title="Editar contrato"
          subtitle="Editar contrato"
        >
          <MenuButton>
            <ButtonLogs routes="payment_contracts" entityId={contractId} />
          </MenuButton>
        </ContentHeader>
        {!isLoading && (
          <TabsForm
            mode="edit"
            refresh={refresh}
            paymentContract={response?.data?.paymentContract}
            tab={tab}
            setTab={setTab}
          />
        )}
      </Container>
    </Page>
  )
}

export default ContractEdit
